var SessionPropertiesEventSerialiser = require('services/control/session-properties-event-serialiser');
var ConversationIDSerialiser = require('conversation/conversation-id-serialiser');
var Codec = require('io/codec');

module.exports = {
    read : function(input) {
        var cid = ConversationIDSerialiser.read(input);
        var events = Codec.readCollection(input, SessionPropertiesEventSerialiser.read);

        return {
            cid : cid,
            events : events
        };
    },
    write : function(output, batch) {
        ConversationIDSerialiser.write(output, batch.cid);
        Codec.writeCollection(output, batch.events);
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/control/session-properties-event-batch-serialiser.js
// module id = 1030
// module chunks = 1